import { CONTAINER_ARGS, Metadata, pick } from '../../../../utils/spds/metadata';
import Super from '../../core/container.gjs';

const METADATA = Metadata.define({
  description: 'Grid container component for layout',
  extends: [pick(CONTAINER_ARGS, [{ name: 'grid', default: true }])],
  name: 'Grid Container',
});

export default class SpdsLayoutGridContainer extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
}

export const LAYOUT_GRID_CONTAINER_METADATA = SpdsLayoutGridContainer.metadata;
